<!--
 * @Author: chenyourong
 * @Date: 2025-05-08 18:06:50
 * @LastEditors: chenyourong
 * @LastEditTime: 2025-06-26 12:34:02
 * @Description: 
 * @FilePath: /vue-admin-template-master/src/views/bill/runningRecord/index.vue
-->
<template>
  <div class="bill-list">
    <Search v-bind="filterAttrs" v-on="filterEvent"></Search>
    <Table
      :list-query-params.sync="listQueryParams"
      v-bind="tableAttrs"
      v-on="tableEvent"
    />
  </div>
</template>

<script>
import Table from "@/components/Table/index.vue";
import Detail from "@/components/Detail/index.vue";
import Search from "@/components/Search/index.vue";
import XLSX from "xlsx";
import { getPathName } from "@/utils/index.js";
import Cookies from "js-cookie";

import { billSerialList } from "@/api/bill";
import { channelList } from "@/api/channel.js";

const DefaultTableQuery = {
  pageNum: 1,
  pageSize: 10,
};
const EXPORT_PAGE_SIZE = 10000;
const EXPORT_REQUEST_TIMEOUT = 120000;

const SERIAL_TYPE_FILTER_OPTIONS = [
  {
    value: "",
    label: "所有",
  },
  {
    value: "recharge",
    label: "充值",
  },
  {
    value: "consume",
    label: "余额扣除",
  },
  {
    value: "freeze",
    label: "锁定",
  },
  {
    value: "unfreeze",
    label: "扣除",
  },
  {
    value: "rollback",
    label: "返还",
  },
  {
    value: "expire",
    label: "取消锁定",
  },
];

function buildRunningRecordFilterOptions() {
  const userType = +Cookies.get("type");
  const options = [
    {
      format: "mulDate",
    },
  ];
  if (userType === 1) {
    options.push(
      {
        type: "multiSelect",
        placeholder: "渠道",
        selectValue: "",
        inputValue: "",
        isSearch: false,
        noShowInput: true,
        options: [],
      },
      {
        type: "multiSelect",
        placeholder: "流水类型",
        selectValue: "",
        inputValue: "",
        isSearch: false,
        noShowInput: true,
        options: SERIAL_TYPE_FILTER_OPTIONS,
      }
    );
  }
  options.push(
    {
      type: "multiSelect",
      placeholder: "请选择",
      selectValue: "voucherId",
      inputValue: "",
      isSearch: false,
      inputWidth: "264px",
      selectWidth: "105px",
      options: [
        {
          label: "券码ID",
          value: "voucherId",
        },
      ],
    },
    {
      type: "button",
    }
  );
  return options;
}

export default {
  name: "businessList",
  components: {
    Table,
    Search,
    Detail,
  },
  data() {
    return {
      // 参数
      listQueryParams: { ...DefaultTableQuery },
      tableData: [],
      tableConfig: [
        {
          label: "操作类型",
          minWidth: "80",
          maxWidth: "140",
          autoWidth: true,
          value: "operationType",
        },
        {
          label: "券码金额",
          minWidth: "80",
          maxWidth: "110",
          autoWidth: true,
          value: "couponAmount",
        },
        {
          label: "券码ID",
          minWidth: "120",
          maxWidth: "220",
          autoWidth: true,
          value: "voucherId",
        },
        {
          label: "资金操作",
          minWidth: "80",
          maxWidth: "140",
          autoWidth: true,
          value: "financialOperations",
        },
        {
          label: "",
          minWidth: "80",
          maxWidth: "120",
          autoWidth: true,
          value: "amount",
        },
        {
          label: "商户金额",
          minWidth: "80",
          maxWidth: "120",
          autoWidth: true,
          value: "merchantSettlement",
        },
        {
          label: "商户",
          minWidth: "90",
          maxWidth: "220",
          autoWidth: true,
          value: "merchantName",
        },
        {
          label: "渠道",
          minWidth: "90",
          maxWidth: "240",
          autoWidth: true,
          value: "channelName",
        },
        {
          label: "流水号",
          minWidth: "120",
          maxWidth: "280",
          autoWidth: true,
          value: "tx_no",
        },
        {
          label: "操作角色",
          minWidth: "80",
          maxWidth: "160",
          autoWidth: true,
          value: "operationRole",
        },
        {
          label: "操作人",
          minWidth: "80",
          maxWidth: "180",
          autoWidth: true,
          value: "operator",
        },
        {
          label: "操作备注",
          minWidth: "80",
          maxWidth: "320",
          autoWidth: true,
          value: "operationRemarks",
        },
        {
          label: "操作端",
          minWidth: "70",
          maxWidth: "120",
          autoWidth: true,
          value: "operatorTerminal",
        },
        {
          label: "操作时间",
          minWidth: "96",
          maxWidth: "190",
          autoWidth: true,
          value: "operatorTime",
        },
      ],
      // 表格加载loading
      loadingStatus: false,
      optionWidth: 148,
      // url参数
      params: {
        pageSize: 10,
        pageNum: 0,
        merchantId: "",
        channelId: "",
        storeId: "",
        voucherId: "",
      },
      filterButtonText: [
        {
          label: "导出Excel",
          type: "primary",
        },
      ],
      filterOptions: buildRunningRecordFilterOptions(),
      multipleSelection: [],
      // dateValue: "",
      type: +Cookies.get("type"),
    };
  },
  computed: {
    // 表格属性
    tableAttrs() {
      const keyword = (this.params.voucherId || "").trim();
      const config = this.tableConfig.map((item) => {
        if (item.value !== "voucherId" || !keyword) {
          return item;
        }
        return {
          ...item,
          format: "highlight",
          highlightKeyword: keyword,
        };
      });
      return {
        // 表头配置
        config,
        // 表格数据
        tableData: this.tableData,
        // loading
        loadingStatus: this.loadingStatus,
        // 操作栏宽度
        optionColumnWidth: this.optionWidth,
        // 是否需要选择
        isSelection: true,
        isHasButtons: false,
        isShowNumber: true,
      };
    },
    // 表格事件
    tableEvent() {
      return {
        // 分页
        subClickPagination: this.handleRefreshList,
        // 表格数据选择
        subSelected: this.handleSelectionChange,
      };
    },
    filterAttrs() {
      return {
        // 按钮名称
        filterButtonText: this.filterButtonText,
        filterOptions: this.filterOptions,
      };
    },
    filterEvent() {
      const events = {
        handleFilterButton: this.handleFilterButton,
        changeDate: this.changeDate,
        clickSearch: this.clickSearch,
      };
      if (this.type === 1) {
        events.handleFilter = this.handleFilter;
      }
      return events;
    },
    amountDes() {
      return function (val) {
        const obj = {
          1: "渠道金额",
          2: "渠道金额",
          3: "商户金额",
          4: "门店金额",
        };
        return obj[val];
      };
    },
  },
  created() {
    if (this.type === 1) {
      this.loadChannelOptions();
    }
    this.getList();
  },
  methods: {
    loadChannelOptions() {
      const channelFilter = this.filterOptions.find(
        (item) => item.placeholder === "渠道"
      );
      if (!channelFilter) {
        return;
      }
      channelList({
        pageSize: 1000,
        pageNum: 0,
      }).then((res) => {
        channelFilter.options = (res.data.list || []).map((val) => ({
          value: val.channelId,
          label: val.channelName,
        }));
        channelFilter.options.unshift({
          value: "",
          label: "所有",
        });
      });
    },
    buildSerialListParams(extra = {}) {
      const payload = {
        ...this.params,
        ...extra,
      };
      if (!payload.channelId) {
        delete payload.channelId;
      }
      if (!payload.type) {
        delete payload.type;
      }
      if (!payload.voucherId) {
        delete payload.voucherId;
      }
      return payload;
    },
    // 获取列表
    async getList() {
      try {
        // 表格加载loading
        this.loadingStatus = true;
        // 分页数据作为参数给服务端
        this.params.pageSize = this.listQueryParams.pageSize;
        this.params.pageNum = this.listQueryParams.pageNum - 1;
        // this.params.date = this.dateValue;
        // 发送请求,请求到的数据格式见下文，
        const { data } = await billSerialList(this.buildSerialListParams());
        if (data.list) {
          data.list.forEach((item) => {
            item.couponAmount = item.couponAmount / 100;
            item.amount = item.amount / 100;
            item.merchantSettlement = item.merchantSettlement / 100;
          });
        }
        this.listQueryParams.total = data.total;
        // 数据给表格
        this.tableData = data.list || [];
        this.tableConfig.forEach((item) => {
          if (item.value === "amount") {
            item.label = this.amountDes(this.type);
          }
        });
        // if ([3, 4].includes(this.type)) {
        //   this.tableConfig = this.tableConfig.filter((item) => {
        //     if ([4].includes(this.type)) {
        //       return !["channelName", "amount", 'merchantSettlement'].includes(item.value);
        //     }
        //     return !["channelName", 'merchantSettlement'].includes(item.value);
        //   });
        // }
        if ([3].includes(this.type)) {
          this.tableConfig = this.tableConfig.filter(
            (item) => !["channelName", 'merchantSettlement'].includes(item.value)
          );
        }
        if ([4].includes(this.type)) {
          this.tableConfig = this.tableConfig.filter(
            (item) => !["channelName", "amount", 'merchantSettlement'].includes(item.value)
          );
        }
        if ([2].includes(this.type)) {
          this.tableConfig = this.tableConfig.filter(
            (item) => !["merchantName", 'merchantSettlement'].includes(item.value)
          );
        }
        this.loadingStatus = false;
      } catch (error) {
        console.log(error);
      }
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    changeDate(val) {
      if (!val || !val.length) {
        delete this.params.startDate;
        delete this.params.endDate;
        return;
      }
      this.params.startDate = val[0];
      this.params.endDate = val[1];
    },
    handleFilter(val) {
      if (this.type !== 1) {
        return;
      }
      if (val.placeholder === "渠道") {
        this.params.channelId = val.selectValue || "";
      }
      if (val.placeholder === "流水类型") {
        if (val.selectValue) {
          this.params.type = val.selectValue;
        } else {
          delete this.params.type;
        }
      }
    },
    // 分页操作
    handleRefreshList() {
      this.getList();
    },
    clickSearch(val) {
      if (val && val.selectValue === "voucherId") {
        this.params.voucherId = (val.inputValue || "").trim();
      }
      this.listQueryParams.pageNum = 1;
      this.getList();
    },
    normalizeSerialExportItem(item) {
      item.couponAmount = item.couponAmount / 100;
      item.amount = item.amount / 100;
      item.merchantSettlement = item.merchantSettlement / 100;
    },
    async fetchAllSerialForExport() {
      const allList = [];
      let pageNum = 0;
      let total = 0;

      while (true) {
        const { data } = await billSerialList(
          this.buildSerialListParams({
            pageSize: EXPORT_PAGE_SIZE,
            pageNum,
          }),
          { timeout: EXPORT_REQUEST_TIMEOUT }
        );
        if (pageNum === 0) {
          total = data.total || 0;
        }
        const list = data.list || [];
        if (!list.length) {
          break;
        }
        list.forEach((item) => this.normalizeSerialExportItem(item));
        allList.push(...list);
        pageNum += 1;
        if (list.length < EXPORT_PAGE_SIZE) {
          break;
        }
        if (total > 0 && allList.length >= total) {
          break;
        }
      }

      return allList;
    },
    async exportExcel() {
      let headers = [
        "操作类型",
        "券码金额",
        "券码ID",
        "资金操作",
        this.amountDes(this.type),
        "商户金额",
        "商户",
        "渠道",
        "流水号",
        "操作角色",
        "操作人",
        "操作备注",
        "操作端",
        "操作时间",
      ];
      let keys = [
        "operationType",
        "couponAmount",
        "voucherId",
        "financialOperations",
        "amount",
        "merchantSettlement",
        "merchantName",
        "channelName",
        "tx_no",
        "operationRole",
        "operator",
        "operationRemarks",
        "operatorTerminal",
        "operatorTime",
      ];
      // if ([3, 4].includes(this.type)) {
      //   keys = keys.filter((item) => {
      //     if ([4].includes(this.type)) {
      //       return !["channelName", "amount", "merchantSettlement"].includes(
      //         item
      //       );
      //     }
      //     return !["channelName", "merchantSettlement"].includes(item);
      //   });
      //   headers = headers.filter((item) => {
      //     if ([4].includes(this.type)) {
      //       return !["渠道", "商户金额", "门店金额"].includes(item);
      //     }
      //     return !["渠道"].includes(item);
      //   });
      // }
      if ([3].includes(this.type)) {
        keys = keys.filter((item) => {
          return !["channelName"].includes(item);
        });
        headers = headers.filter((item) => {
          return !["渠道"].includes(item);
        });
      }

      if ([4].includes(this.type)) {
        keys = keys.filter((item) => {
          return !["channelName", "amount", "merchantSettlement"].includes(
            item
          );
        });
        headers = headers.filter((item) => {
          return !["渠道", "商户金额", "门店金额"].includes(item);
        });
      }

      if ([2].includes(this.type)) {
        keys = keys.filter((item) => {
          return !["merchantName", "merchantSettlement"].includes(item);
        });
        headers = headers.filter((item) => {
          return !["商户", "商户金额"].includes(item);
        });
      }
      let exportData = [];
      let arr = [];
      const loading = this.$loading({
        lock: true,
        text: "正在导出，请稍候...",
      });
      try {
        if (this.multipleSelection.length) {
          arr = this.multipleSelection;
        } else {
          arr = await this.fetchAllSerialForExport();
        }
        if (!arr.length) {
          this.$message.warning("暂无数据可导出");
          return;
        }
        exportData = arr.map((item) => {
          return keys.map((key) => item[key]);
        });
        exportData.unshift(headers);
        const ws = XLSX.utils.aoa_to_sheet(exportData);
        ws["!cols"] = [
          { wch: 12 },
          { wch: 12 },
          { wch: 12 },
          { wch: 15 },
          { wch: 12 },
          { wch: 12 },
          { wch: 12 },
          { wch: 20 },
          { wch: 15 },
          { wch: 25 },
          { wch: 25 },
          { wch: 15 },
          { wch: 12 },
          { wch: 21 },
        ];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        XLSX.writeFile(wb, `流水记录${getPathName()}.xlsx`);
      } catch (error) {
        console.log(error);
        this.$message.error("导出失败，请稍后重试");
      } finally {
        loading.close();
      }
    },
    // 点击右上角添加门店或者删除门店按钮
    async handleFilterButton(val) {
      if (val === "导出Excel") {
        this.exportExcel();
      }
    },
  },
};
</script>
<style lang="scss">
.bill-list {
  .filter-container {
    .el-input {
      width: 145px;
      input {
        height: 32px;
      }
      .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
    }
    .el-input__icon {
      line-height: 32px;
    }
    .el-button {
      padding: 12px;
    }
    .filter-container__right {
      .el-button {
        width: 88px;
        height: 32px;
        line-height: 32px;
        padding: 0;
        font-size: 14px;
      }
      .el-button--primary {
        background: #1890ff;
      }
      .el-button--info {
        background: #f5f5f5;
        color: rgba(0, 0, 0, 0.25);
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
.bill-list {
  .show-pwd {
    position: absolute;
    right: 60px;
    top: 0;
    font-size: 16px;
    color: #000;
    cursor: pointer;
    user-select: none;
  }
  .char-count {
    text-align: right;
    color: #666;
    font-size: 12px;
    margin-top: 4px;
  }

  .limit-reached {
    color: #f56c6c;
    font-weight: bold;
  }
}
</style>
